    export const PROFILEMOCK  =  // modified to an array for in memory api to work
      {
      adId: "sdf1ndj",
      firstName: "Neil",
      lastName: "Jeffries",
      email: "0562993@ups.com",
      vanList: [
        {
          vanId: "414845",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414846",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414847",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414848",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414849",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414850",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414865",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414866",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414867",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414894",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414895",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414896",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414897",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414898",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "414899",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "416355",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419679",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419680",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419681",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419682",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419683",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419684",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419685",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419686",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419687",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419688",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "419689",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "829916",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "829917",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "829918",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 1",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 10",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 11",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 2",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 3",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 4",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 5",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 6",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 7",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 8",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Rental 9",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Test",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        },
        {
          vanId: "Test2",
          driverId: "",
          driverName: "",
          driverInitials: "UPS"
        }
      ],
      userRoles: ["cvv_coordinator"]
    }
  ;

